import BlinkingLogo from "@/shared/components/ui/loading/blinking-logo.tsx";

const SkeletonPage = () => {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <BlinkingLogo size="xl" text="" />
    </div>
  );
};

export default SkeletonPage;
